interface SafeAreaSpacerProps {
  position: 'top' | 'bottom';
  className?: string;
  bg?: string;
}

/**
 * Safe area spacer component for handling device notches and home indicators
 * Uses CSS variables provided by Despia Native runtime
 */
export function SafeAreaSpacer({ position, className = '', bg }: SafeAreaSpacerProps) {
  const cssVariable = position === 'top' ? 'var(--safe-area-top)' : 'var(--safe-area-bottom)';
  
  return (
    <div 
      className={`w-full ${bg || ''} ${className}`}
      style={{ height: cssVariable }}
      aria-hidden="true"
    />
  );
}
